import { render, staticRenderFns } from "./DashboardIncomingMessages.vue?vue&type=template&id=f1501a7e&scoped=true"
import script from "./DashboardIncomingMessages.vue?vue&type=script&lang=js"
export * from "./DashboardIncomingMessages.vue?vue&type=script&lang=js"
import style0 from "./DashboardIncomingMessages.vue?vue&type=style&index=0&id=f1501a7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1501a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1501a7e')) {
      api.createRecord('f1501a7e', component.options)
    } else {
      api.reload('f1501a7e', component.options)
    }
    module.hot.accept("./DashboardIncomingMessages.vue?vue&type=template&id=f1501a7e&scoped=true", function () {
      api.rerender('f1501a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardIncomingMessages.vue"
export default component.exports